module.exports = __webpack_public_path__ + "img/female_x5F_chinese.9c776aea.svg";